import { Card, Col, Layout, Row, Typography } from "antd";
import { useNavigate } from "react-router";

import { useAuthenticated } from "../auth/SessionProvider";
import { MODULE_REGISTRY } from "../modules/registry";
import { Brand } from "./Brand";
import { UserBar } from "./UserBar";

/** Landing page: one tile per module the current role may enter. */
export function HomeGrid() {
  const { principal } = useAuthenticated();
  const navigate = useNavigate();
  const modules = MODULE_REGISTRY.filter((module) => principal.modules.includes(module.id));
  return (
    <Layout className="app-layout">
      <Layout.Header className="app-header">
        <Brand />
        <UserBar />
      </Layout.Header>
      <Layout.Content className="home-content">
        <Typography.Title level={4} className="home-title">请选择功能</Typography.Title>
        <Row gutter={[20, 20]}>
          {modules.map((module) => (
            <Col key={module.id} xs={24} sm={12} md={8} lg={6}>
              <Card hoverable className="module-tile" onClick={() => navigate(`/m/${module.id}`)}>
                <div className="module-tile-icon">{module.icon}</div>
                <Typography.Title level={5} className="module-tile-title">{module.title}</Typography.Title>
                <Typography.Text type="secondary">{module.description}</Typography.Text>
              </Card>
            </Col>
          ))}
        </Row>
      </Layout.Content>
    </Layout>
  );
}
